/**
 * Order Service Hooks
 * React hooks for accessing order management services
 */
import { useCCMS } from '../useCCMS';
/**
 * Hook to access all order-related services
 * @returns OrderServices object containing all order service instances
 */
export function useOrdersServices() {
    const { services } = useCCMS();
    if (!services?.orders) {
        throw new Error('Order services not available. Ensure CCMSProvider is configured with order services.');
    }
    return services.orders;
}
/**
 * Hook to access OrderService
 */
export function useOrderService() {
    return useOrdersServices().order;
}
/**
 * Hook to access OrderLineService
 */
export function useOrderLineService() {
    return useOrdersServices().orderLine;
}
/**
 * Hook to access OrderLineAddOnService
 */
export function useOrderLineAddOnService() {
    return useOrdersServices().orderLineAddOn;
}
/**
 * Hook to access OrderLineVariantService
 */
export function useOrderLineVariantService() {
    return useOrdersServices().orderLineVariant;
}
/**
 * Hook to access OrderPaymentService
 */
export function useOrderPaymentService() {
    return useOrdersServices().orderPayment;
}
/**
 * Hook to access OrderStatusService
 */
export function useOrderStatusService() {
    return useOrdersServices().orderStatus;
}
/**
 * Hook to access OrderLineStatusService
 */
export function useOrderLineStatusService() {
    return useOrdersServices().orderLineStatus;
}
/**
 * Hook to access PaymentStatusService
 */
export function usePaymentStatusService() {
    return useOrdersServices().paymentStatus;
}
/**
 * Hook to access OrderNotificationService
 */
export function useOrderNotificationService() {
    return useOrdersServices().orderNotification;
}
/**
 * Hook to access OrderShopService
 */
export function useOrderShopService() {
    return useOrdersServices().shop;
}
/**
 * Hook to access OrderModelViewService
 */
export function useOrderModelViewService() {
    return useOrdersServices().orderModelView;
}
/**
 * Hook to access OrderLineModelViewService
 */
export function useOrderLineModelViewService() {
    return useOrdersServices().orderLineModelView;
}
/**
 * Hook to access OrderPaymentModelViewService
 */
export function useOrderPaymentModelViewService() {
    return useOrdersServices().orderPaymentModelView;
}
//# sourceMappingURL=useOrdersServices.js.map